/* eslint-disable max-statements */
import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import dataAids from '../../constants/dataAids';

const yotpoContainerStyles = renderMode => {
  const editPreviewCheck = renderMode !== 'PUBLISH';
  return {
    pointerEvents: `${editPreviewCheck ? 'none' : 'inherit'}`,
    opacity: `${editPreviewCheck ? '0.5' : '1'}`
  };
};

const formatDescription = description_raw => {
  if (!description_raw) {
    return null;
  }

  let result;

  try {
    result = JSON.parse(description_raw).blocks[0].text;
  } catch (e) {
    result = description_raw;
  }

  if (result.length > 1000) {
    result = `${result.substring(0, 999)}...`;
  }

  return result;
};

class Yotpo extends React.Component {
  render() {
    const { app_key: appKey } = OlsConfigStore.getState().yotpo_config || {};
    const { product, className, style, domainName } = this.props;
    if (!appKey || !product) {
      return null;
    }

    const { id, name, slug, description_raw, ols_product_id: olsProductId } = product;
    const { yotpoProductId } = this.props;
    let productId = id;
    if (yotpoProductId != null) {
      productId = yotpoProductId;
    } else if (olsProductId != null) {
      productId = olsProductId;
    }
    let shopRoute = this.props.shopRoute || '/';
    shopRoute = shopRoute + (shopRoute.slice(-1) === '/' ? '' : '/');
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
    const siteUrl = `${protocol}//${domainName}`;
    const productUrl = `${siteUrl}${shopRoute}ols/products/${slug}`;
    const assets = product.assets || product.images;
    let assetUrl =
      assets && assets.length ? assets[0].large_url : OlsConfigStore.getState().noProductImage;
    assetUrl = encodeURIComponent(`https:${assetUrl}`);
    const description = formatDescription(description_raw);

    const { Block } = UX2.Element;
    return (
      <Block
        className={ className }
        style={ style }
        data-appkey={ appKey }
        data-domain={ siteUrl }
        data-product-id={ `${productId}` }
        data-yotpo-product-id={ `${productId}` }
        data-name={ name }
        data-description={ description }
        data-url={ productUrl }
        data-image-url={ assetUrl }
      />
    );
  }
}

Yotpo.propTypes = {
  product: PropTypes.object,
  yotpoProductId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object,
  domainName: PropTypes.string,
  shopRoute: PropTypes.string
};

export const ProductStarRating = ({
  product,
  yotpoProductId,
  containerStyle,
  renderMode,
  domainName,
  shopRoute
}) => {
  const { app_key: appKey } = OlsConfigStore.getState().yotpo_config || {};
  if (!appKey || !product) {
    return null;
  }

  const styles = {
    outer: {
      textAlign: 'center',
      ...containerStyle
    },
    inner: {
      display: 'inline-block',
      width: 'auto',
      ...yotpoContainerStyles(renderMode)
    }
  };

  const { Block } = UX2.Element;
  return (
    <Block
      className='ratings-review-wrapper product-list'
      data-aid={ `${dataAids.PRODUCT_GROUP_STAR_RATING_RENDERED}` }
      style={ styles.outer }
    >
      <Block className='single-product-review'>
        <Yotpo
          product={ product }
          yotpoProductId={ yotpoProductId }
          className='yotpo bottomLine'
          style={ styles.inner }
          domainName={ domainName }
          shopRoute={ shopRoute }
        />
      </Block>
    </Block>
  );
};

ProductStarRating.propTypes = {
  product: PropTypes.object.isRequired,
  yotpoProductId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  containerStyle: PropTypes.object,
  renderMode: PropTypes.string,
  domainName: PropTypes.string,
  shopRoute: PropTypes.string
};

ProductStarRating.defaultProps = {
  containerStyle: {},
  renderMode: ''
};
